import { Box } from '@mui/material';

export default function SectionContainer({ children }: SectionContainerProps) {

    return (
        <Box
            sx={{
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                gap: { xs: 2, md: 3, lg: 4, xl: 5 },
                minHeight: '100%',
                paddingX: { xs: 2, md: 4, lg: 6, xl: 8 }
            }}>
            {children}
        </Box>
    );

}